import Container from './container';
import Header from './header';
import Footer from './footer';
import Aside from './aside';
import Main from './main';

Container.Header = Header;
Container.Footer = Footer;
Container.Aside = Aside;
Container.Main = Main;

export default Container;
